/**
 * Sticky Header Functionality
 * Shows the sticky header when the original header height is scrolled
 */
export default function stickyHeader() {
    const stickyHeaderWrapper = document.querySelector('.sticky-header-wrapper');
    const originalHeader = document.querySelector('#masthead.site-header');
    
    if (!stickyHeaderWrapper || !originalHeader) {
        return;
    }
    
    function isDesktopScreen() {
        return window.innerWidth > 728;
    }
    
    if (!isDesktopScreen()) {
        return;
    }
    
    let headerHeight = 0;
    let ticking = false;
    
    function calculateHeaderHeight() {
        headerHeight = originalHeader.offsetHeight;
    }
    
    function handleScroll() {
        if (!isDesktopScreen()) {
            return;
        }
        
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const scrollY = window.scrollY || window.pageYOffset;
                
                if (scrollY >= headerHeight) {
                    stickyHeaderWrapper.classList.remove('-translate-y-[200%]');
                    stickyHeaderWrapper.classList.add('translate-y-0');
                } else {
                    stickyHeaderWrapper.classList.remove('translate-y-0');
                    stickyHeaderWrapper.classList.add('-translate-y-[200%]');
                }
                
                ticking = false;
            });
            
            ticking = true;
        }
    }
    
    // Initialize
    function init() {
        calculateHeaderHeight();
        
        window.addEventListener('resize', () => {
            if (!isDesktopScreen()) {
                stickyHeaderWrapper.classList.remove('translate-y-0');
                stickyHeaderWrapper.classList.add('-translate-y-[200%]');
                return;
            }
            
            calculateHeaderHeight();
            handleScroll(); // Recheck scroll position after resize
        });
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        handleScroll();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}

